export default __webpack_public_path__ + "static/media/triviapp.702e46eb.png";